import React, { Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/Loader';
import { STUDENTS_INFO } from '../../redux/actions/studentsActions';
import queryString from 'query-string';
import { setSearchTerm } from '../../redux/actions/searchActions';
import '../../assets/styles/custom/pages/carousel.scss';
const TapPageStudentsCarousel = React.lazy(() =>
    import(/* tap-page-students-carousel */ '../../components/TapPageStudentsCarousel')
);

const CarouselPage = () => {
    const dispatch = useDispatch();

    const students = useSelector((state) => state.students);
    const searchTerms = useSelector((state) => state.searchTerms);

    useEffect(() => {
        const queryTerms = queryString.parse(window.location.search); // take the ?search= from the URL if it exists

        let searchArray = null;
        let getStudentsInfo = true;
        if (searchTerms.items.length) {
            searchArray = searchTerms.items;
        } else if (queryTerms.search) {
            searchArray = queryTerms.search.split(',');
            searchArray.map((item) => {
                dispatch(setSearchTerm(item.trim()));
            });
        } else if (queryTerms.term || queryTerms.terms) {
            const terms = queryTerms.term ? queryTerms.term : queryTerms.terms;
            if (typeof terms === 'string') {
                searchArray = terms.split(',');
            } else {
                searchArray = terms;
            }
            searchArray.map((item) => {
                dispatch(setSearchTerm(item.trim()));
            });
        } else if (queryTerms.searchTerms && queryTerms.searchTerms.length) {
            // for new search terms which sent as array
            try {
                searchArray = [];
                if (typeof queryTerms.searchTerms === 'string') {
                    searchArray.push(queryTerms.searchTerms);
                    dispatch(setSearchTerm(queryTerms.searchTerms.trim()));
                } else {
                    queryTerms.searchTerms.map((item) => {
                        searchArray.push(item.trim());
                        dispatch(setSearchTerm(item.trim()));
                    });
                }
            } catch (e) {
                console.log(e);
            }
        } else {
            getStudentsInfo = false;
            dispatch({
                type: STUDENTS_INFO,
                payload: {
                    isCarousel: true,
                    search: null,
                    random: false,
                },
            });
        }

        if (getStudentsInfo) {
            dispatch({
                type: STUDENTS_INFO,
                payload: {
                    isCarousel: true,
                    random: !!searchArray,
                    search: searchArray,
                },
            });
        }
    }, []);

    const items =
        students && students.items ? (
            <Suspense fallback={null}>
                <TapPageStudentsCarousel
                    key={1}
                    students={students.items}
                    studentsData={students}
                    searchTerms={searchTerms}
                />
            </Suspense>
        ) : (
            <></>
        );

    return (
        <div id="page-body" className="page-body carousel-page js-index">
            <section className="tap-page">
                {students && students.isLoading ? (
                    <div className="loader-block-stick">
                        <Loader />
                    </div>
                ) : (
                    <div className="widget-body">
                        <div className="container">{items}</div>
                    </div>
                )}
            </section>
        </div>
    );
};

export default CarouselPage;
